/**
 * Environment validation schemas.
 */
import { z } from "zod";
/** Environment schema - strictly typed */
export const environmentSchema = z.enum(["dev", "staging", "prod"]);
